export class Vehicle {
  constructor(
    public readonly id: string,
    public readonly trackingId: string,
    public readonly licensePlate: string,
    public readonly assignedEmployeeId: string|null,
    public readonly createdAt: Date,
    public readonly updatedAt: Date,
  ) {
  }

  static fromJson(json: any): Vehicle {
    return new Vehicle(
      String(json['id']),
      json['tracking_id'],
      json['license_plate'],
      json['assigned_employee_id'],
      new Date(json['created_at']),
      new Date(json['updated_at']),
    )
  }
}